const home = {
    welcome: 'Welcome to EasyHireAi',
    description: 'This is a management dashboard based on Vue 3 + TypeScript + shadcn-vue + Tailwind CSS.',
  }

export default home
